import { render } from "./provision.vue?vue&type=template&id=cbaa231c"
import script from "./provision.vue?vue&type=script&lang=js"
export * from "./provision.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__